import React, {FC} from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';

import {KnowledgeBasePanelId} from '../../../../../src/store/panels/panelStateBase';
import {
  KnowledgeBaseParameters,
  KnowledgeBaseParametersTypesEnum,
} from '../../../store/src/knowledgeBaseParameters';
import {makeMapStateToProps} from '../../../store/src/knowledgeBaseReselectHelpers';
import {makeGetKnowledgeBaseParameters} from '../../../store/src/panel/knowledgeBasePanelSelectors';
import {KnowledgeBaseNavigation} from '../components/navigation/knowledgeBaseNavigation';
import {Article} from './article';
import {List} from './list';
import {Settings} from './settings';

/*
 * Styles.
 */

const PageWrapperDiv = styled.div`
  display: flex;
  height: 100%;
`;

/*
 * Props.
 */

interface PageRoutingContainerProps {
  panelId: KnowledgeBasePanelId;
}

interface PageRoutingComponentProps {
  parameters: KnowledgeBaseParameters;
}

/*
 * Component.
 */

const PageRoutingComponent: FC<PageRoutingComponentProps> = (props) => {
  const {parameters} = props;

  return (
    <PageWrapperDiv>
      <KnowledgeBaseNavigation currentParameterType={parameters.type} />
      {mapRouteToComponent(parameters.type)}
    </PageWrapperDiv>
  );
};

function mapRouteToComponent(parametersType: KnowledgeBaseParametersTypesEnum) {
  switch (parametersType) {
    case KnowledgeBaseParametersTypesEnum.ARTICLE:
      return <Article />;
    case KnowledgeBaseParametersTypesEnum.SETTINGS:
      return <Settings />;
    case KnowledgeBaseParametersTypesEnum.LIST:
    default: {
      return <List />;
    }
  }
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<PageRoutingContainerProps>()(() => ({
  parameters: makeGetKnowledgeBaseParameters(),
}));

export const PageRoutingContainer = connect(mapStateToProps)(PageRoutingComponent);
